module.exports = __webpack_public_path__ + "img/enterprise1.931d3a05.png";